const en = {
    homeTitle: 'Home',
    menuCategory: 'Shopping',
    menuSales: 'Sale',
    menuSaved: 'Saved',
    login: {
        title: 'Hi There!',
        forgotPassWord: 'Forgot password?',
        register: 'Register now?',
        haveAccount: 'Have an account? Login now!',
        haveNotAccount: 'Do not have an account? Register now!',
        existedEmail: 'Email is existed',
        existedPhone: 'Contact number is existed',
        nameRequired: 'Name is required!',
        emailRequired: 'Email is required!',
        phoneRequired: 'Phone is required!',
        loginTitle: 'Please fill out the following form to login with Billion Girl',
        registerTitle: 'Please fill out the following form to register with Billion Girl',
        registerTitleSub:
            'We will save the details you provide to support your transactions on our website',
        registerNote:
            '(*) Note: If you have ever shopped with BILLION GIRL, please enter the accumulate points phone number to synchronize shopping information',
        txtLogin: 'Login',
        txtRegister: 'Register',
        wrongOTP: 'Wrong OTP code. Please check and re-enter!',
        sentOTP: 'OTP has been sent to phone number: {{phone}}.',
        enterOTP: 'Please check and enter the OTP code',
        verifyInformation: 'Verify phone number ({{timeOut}})',
        verifyOTP: 'Verify OTP code',
        btnResend: 'Resend ({{timeOut}})',
        btnVerify: 'Verify OTP',
        msgOTPInvalid:
            'The SMS verification code used to create the phone auth credential is invalid.',
        msgOTPExpired:
            'The SMS code has expired. Please re-send the verification code to try again.',
        msgOTPTooManyRequest:
            'You have requested too many times, please clear your cache and try again later.'
    },
    reset: {
        changePasswordFailed: 'Change password failed!'
    },
    notFound: {
        header: 'Page Not Found',
        title: 'Page not found',
        subTitle:
            'The page you requested could not be found at this time. We apologize for the inconvenience, please try again later!'
    },
    about: {
        title_1: 'Beyond the SEXY',
        title_2: 'Beyond the BEAUTY',
        content_1:
            'Bringing a charming experience to customers Made of high-quality materials, with superior elasticity and elasticity, no loss of form after many uses.',
        content_2:
            'Sexy, modern, liberal but not only that. Honoring the beauty of women by designs that emphasize elegance and sophistication, and the meticulous processing of Billion Girl team.'
    },
    cart: {
        bag: 'Cart',
        totalBags: 'Total products: {{total}}',
        product: 'Product',
        desc: 'Description',
        unit: 'Unit',
        price: 'Price',
        outOfStockNote:
            '(*) Your shopping cart has products that are out of stock. Please delete the product or continue to pay without the products that are out of stock'
    },
    contact: {
        title: 'Contact us',
        online: 'Online from 8:00 - 17:00 | Monday - Saturday',
        contact: 'Send information about Billion Girl mailbox for answers & related issues',
        address:
            'HCM: 780/10 Su Van Hanh, Ward 12, District 10 | Hanoi: 3rd Floor, 82 Nguyen Luong Bang, Dong Da, Hanoi',
        openTime: 'Open: 09:30 - 21:30 | Days of week',
        reason: 'Contact reason',
        msgReason: 'Contact reason is required',
        name: 'Full name',
        msgName: 'Name is required',
        email: 'Email address',
        orderNumber: 'Order code',
        content: 'Comment',
        msgContent: 'Comment is required',
        msgSendMessageSuccess: 'Send feedback success',
        msgSendMessageFailed: 'Send feedback failed'
    },
    home: {
        feature: 'Feature Product',
        collection: 'Shop the collection'
    },
    wish: {
        title: 'Saved',
        price: 'Price',
        select: 'Select option',
        product: 'Product',
        description: 'Description'
    },
    filter: {
        title: 'Filter',
        color: 'Color',
        size: 'Size',
        styles: 'Category',
        price: 'Price',
        apply: 'Apply',
        clear: 'Clear Filter'
    },
    orderSummary: {
        shippingFee: 'Shipping Fee',
        price: 'Price',
        discount: 'Discount',
        select: 'Select option',
        product: 'Product',
        desc: 'Description',
        unit: 'Unit',
        size: 'Size',
        standardShipping: 'Standard delivery',
        deliveryFeeNote:
            '(*) The delivery fee is 30,000 VND for all areas (Diamond customers are exempt from this fee).',
        customer: 'Customer',
        receiver: 'Receiver',
        birthday: 'Birthday'
    },
    header: {
        langEN: 'English',
        langVN: 'Vietnamese',
        userProfile: 'User Profile',
        orderHistory: 'Order History',
        management: 'Admin Page',
        changePassword: 'Change Password',
        logOut: 'Log Out',
        search: 'Search ...',
        menuCategory: 'SHOPPING',
        menuSales: 'SALE',
        subMenuSale: 'Sale products',
        menuContact: 'INFORMATION',
        menuAbout: 'ABOUT US',
        cartEmpty: 'No product in cart',
        shopping: 'Start Shopping',
        viewCart: 'View cart',
        cart: 'Cart: {{total}}',
        total: 'Total: {{total}}',
        noSale: 'No Product Sale',
        allProduct: 'All Product',
        noSaleProduct: 'No Product Sale'
    },
    footer: {
        followTitle: 'FOLLOW US ON FACEBOOK GROUP FOR MORE INFORMATION',
        subscribe: "Let's be a BillionGirl Member",
        btnSubscribe: 'Subscribe',
        about: 'About Us',
        store: 'Stores',
        contact: 'Contact Us',
        policy: 'Policy',
        subscribeSuccess: 'Subscribe success',
        returnPolicy: 'Return Policy',
        deliveryPolicy: 'Delivery Policy',
        securityPolicy: 'Security Policy',
        information: 'Shopping Guide',
        shoppingGuide: 'Shopping Guide',
        payment: 'Payment',
        returnProduct: 'Process and method of exchanging',
        askQuestions: 'Frequently asked Questions',
        delivery: 'Delivery',
        headerStore: 'STORE',
        headerShoppingGuide: 'SHOPPING GUIDE',
        headerPayment: 'PAYING',
        headerDelivery: 'DELIVERY',
        headerQuestion: 'FAQ',
        headerReturnPolicy: 'EXCHANGE POLICY',
        headerReturnProcess: 'PROCESS AND HOW TO EXCHANGE',
        headerSecurity: 'DATA PRIVACY POLICY',
        headerDeliveryPolicy: 'DELIVERY POLICY',
        headerRewardPolicy: 'HOW TO ACCUMULATE BONUS POINTS'
    },
    profile: {
        name: 'Name',
        phone: 'Phone',
        province: 'Province/ City',
        ward: 'Ward',
        role: 'Role',
        email: 'Email',
        birthday: 'Birthday',
        district: 'District',
        address: 'Address detail',
        holderCity: 'Select a Provinces/ City',
        holderDistrict: 'Select a District',
        tittle: 'My account',
        detail: 'Personal information',
        updateDetail: 'Update personal information',
        history: 'Purchase History',
        orderHistory: 'Order history',
        invoiceHistory: 'Invoice History',
        returnHistory: 'Return history',
        reward: 'How to accumulate bonus points',
        memberCard: 'Standard',
        memberCardGold: 'Gold',
        memberCardDiamond: 'Diamond',
        updateInfo:
            'You may access and modify your personal details (name, billing address, phone number, etc.) to facilitate your future purchases and inform Notify us of any changes in contact information',
        updateEmail: 'Update email address',
        updateEmailAlert:
            'If you would like to update the email address associated with this account, please fill in the following information. Password required for security reasons',
        updateAddress: ' Update address',
        updateAddressAlert:
            'If you want to update your address, please provide the following information',
        member: 'Membership: {{name}}',
        rewardPoint: 'Reward point: {{point}}',
        btnSyncPoint: 'Sync reward point',
        msgSyncSuccess: 'Sync information success',
        msgSyncFailed: 'Sync information failed',
        msgUpdateSuccess: 'Update information success',
        msgUpdateFailed: 'Update information failed',
        msgUpdateEmailSuccess: 'Update email success',
        msgUpdateEmailFailed: 'Update email success',
        txtPasswordRequired: 'Password required',
        holderBirthday: 'Select date',
        currentCart: 'Your current card {{card}}',
        standardPromotion: 'Enjoy shopping with Standard card',
        goldPromotion: 'Enjoy {{ratio}}% discount with Gold card',
        diamondPromotion: 'Enjoy {{ratio}}% discount with Diamond card',
        extraPhoneNote:
            'Phone number is information to accumulate points. Please contact BILLIONGIRL directly for changes.',
        extraBirthdayNote:
            'Please contact BILLIONGIRL to change your date of birth to receive an offer in your birthday month',
        totalPrice: 'Total price: {{totalPrice}}',
        totalReturn: 'Total return: {{totalPrice}}',
        subscribe: 'Subscribe',
        unsubscribe: 'Unsubscribe',
        height: 'Height',
        weight: 'Weight',
        loyaltySyncNote: 'Your accumulated points will usually be synchronized within 24 hours, if you want to synchronize sooner, please contact our customer service'
    },
    order: {
        user: 'User',
        phone: 'Phone',
        price: 'Price',
        shippingAddress: 'Shipping Address',
        paymentMethod: 'Payment Method',
        deliveryMethod: 'Delivery Method',
        status: 'Status',
        note: 'Note',
        msgName: 'Name is required!',
        msgPrice: 'Price is required!',
        msgPhone: 'Phone is required!',
        msgShipping: 'Shipping Address is required!',
        msgPayment: 'Payment Method is required!',
        msgDelivery: 'Delivery Method is required!',
        msgStatus: 'Status is required!',
        msgAddress: 'Address is required!',
        shippingFee: 'Shipping Fee',
        totalPrice: 'Total Price',
        orderDate: 'Order Date',
        shippingDate: 'Shipping Date',
        btnAction: 'Action',
        image: 'Image',
        color: 'Color',
        size: 'Size',
        discount: 'Discount',
        quantity: 'Quantity',
        name: 'Product Name',
        totalItemPrice: 'Total items price',
        saleOff: 'Discount',
        membershipDiscount: 'Membership Discount',
        fixSale: 'Customer Sale',
        totalOrder: 'Total Price',
        holderSearch: 'Search by order code, customer code or customer name',
        orderHistory: 'Order History',
        holderInvoiceSearch: 'Search by code, customer code or customer name',
        orderCode: 'Code',
        purchaseDate: 'Purchase Date',
        total: 'Total',
        totalPayment: 'Total Payment',
        statusValue: 'Status',
        financialStatus: 'Financial Status',
        carrierStatus: 'Carrier Status',
        orderID: 'Order ID',
        description: 'Description',
        discountOrder: 'Discount order',
        orderStatus: {
            temporary: 'Temporary',
            inDelivery: 'In Delivery',
            finished: 'Finished',
            cancelled: 'Cancelled',
            confirmed: 'Confirmed'
        },
        orderFinancialStatus: {
            pending: 'Pending',
            authorized: 'Authorized',
            partially_paid: 'Partially Paid',
            paid: 'Paid',
            partially_refunded: 'Partially Refunded',
            refunded: 'Refunded',
            voided: 'Voided'
        }
    },
    invoice: {
        totalProduct: 'Total Product:',
        totalItemPrice: 'Total Price:',
        discount: 'Discount:',
        discountInvoice: 'Invoice discount ({{discount}} %):',
        deliveryFee: 'Delivery Fee:',
        total: 'Need to Pay',
        totalPayment: 'Payed',
        paymentInfo: 'Payment Information',
        paymentMethod: 'Payment Method',
        paymentPrice: 'Payment',
        paymentDate: 'Purchase Date',
        paymentStatus: 'Payment Status',
        note: 'Note',
        deliveryCode: 'Delivery Code',
        receiver: 'Receiver',
        customerName: 'Customer Name',
        invoiceID: 'ID',
        invoiceCode: 'Code',
        customerId: 'Customer ID',
        customerCode: 'Customer Code',
        status: 'Status',
        description: 'Description',
        discountRatio: 'Discount (%)',
        invoiceStatus: {
            finished: 'Finished',
            cancelled: 'Cancelled',
            processing: 'Processing',
            canNotDelivery: 'Can not delivery'
        }
    },
    return: {
        code: 'Code',
        invoiceId: 'Invoice ID',
        returnDate: 'Return Date',
        returnTotal: 'Return Total',
        totalPayment: 'Total Payment',
        statusValue: 'Status',
        returnDiscount: 'Return Discount',
        returnFee: 'Return Fee',
        description: 'Description',
        total: 'Total Return',
        searchHolder: 'Search by code, customer code or customer name',
        totalPrice: 'Total products price',
        returnStatus: {
            finished: 'Finished',
            cancelled: 'Cancelled'
        }
    },
    productEntity: {
        name: 'Name',
        color: 'Color',
        discount: 'Discount',
        discountPercent: 'Discount Percent',
        discountValue: 'Discount amount',
        description: 'Description',
        titleEditColor: 'Edit color',
        titleCreateColor: 'Create color',
        titleEditCategory: 'Edit Category',
        titleCreateCategory: 'Create category',
        titleEditDiscount: 'Edit Discount',
        titleCreateDiscount: 'Create discount',
        titleEditSize: 'Edit Size',
        titleCreateSize: 'Create Size',
        holderSearchColor: 'Search by name',
        msgName: 'Name is required!',
        msgDescription: 'Description is required!',
        msgColor: 'Color is required!',
        msgImage: 'Image is required!',
        msgDiscount: 'Discount is required!',
        image: 'Image',
        imageChange: 'Change Image',
        isActive: 'Status',
        withMember: 'With Membership',
        active: 'Active',
        deActive: 'DeActive',
        msgUpdateSuccess: 'Update success',
        msgDeleteSuccess: 'Delete success',
        isDisplay: 'Display Homepage',
        cover: 'Cover',
        url: 'URL',
        bankName: 'Bank name',
        accountNumber: 'Account number',
        msgUpdateSaleCover: 'Update cover success',
        saleCover: 'Sale page cover',
        productDisplay: 'Product Display setting',
        categoryDisplay: 'Category Display setting',
                msgWarningCanNotDelete: 'Can not delete!',
        msgProductAssociated: 'These item(s) is being linked to the products below. Please remove the link before deletion!'
    },
    layout: {
        title: 'Title',
        subTitle: 'Sub Title',
        position: 'Title Position',
        coverImage: 'Cover',
        msgNameRequired: 'Name image is required!',
        holderSearch: 'Search by name, title or sub-title',
        status: 'Status',
        msgUpdateSuccess: 'Update layout success',
        msgUpdateFailed: 'Update layout failed',
        display: 'Display',
        useVideo: 'Use video',
        name: 'Name'
    },
    collection: {
        relativeProduct: 'Relative Product',
        holderSearch: 'Search by name',
        name: 'Name',
        presentImage: 'Present Image',
        collectionImage: 'Collection Images',
        description: 'Description',
        msgName: 'Name is required!',
        msgDescription: 'Description is required!',
        msgRelativeProduct: 'Relative Product is required!',
        msgPresentImage: 'Present is required!',
        msgCollectionImage: 'Collection image is required!'
    },
    history: {
        entityId: 'Entity ID',
        entity: 'Entity',
        action: 'Action',
        author: 'Author',
        newValue: 'New Value',
        oldValue: 'Old Value',
        updateDate: 'Update Date',
        holderSearch: 'Search by name'
    },
    follower: {
        status: 'Status',
        active: 'Active',
        deActive: 'DeActive',
        email: 'Email',
        holderSearch: 'Search followers by email',
        msgEmail: 'Email is required!',
        header: 'Edit follower',
        createdDate: 'Subscribe date'
    },
    payment: {
        paymentMethod: 'Payment Method',
        deliveryMethod: 'Delivery Method',
        shippingMethod: 'Shipping Method',
        shippingInfo: 'Shipping Information',
        productList: 'Product List',
        orderDetail: 'Order Detail',
        confirmOrder: 'Confirm order',
        noProduct: '(*) Your shopping cart has no products. Please come back to',
        overInventory: 'Your shopping cart contains products that are out of stock, or exceed the quantity that can be ordered. Please check the product information again.',
        productName: 'Product',
        available: 'Available',
        ordered: 'Ordered',
        editCart: 'Update cart'
    },
    paymentResult: {
        msgOrderSuccess: 'Order Success!',
        msgContact: 'Billion Girl will contact you within the next 24 hours',
        msgOrderFail: 'An error occurred during ordering!',
        msgSorry: 'Billion is very sorry for this bad experience',
        msgReContact:
            'Please redo the transaction or contact Billion directly via hotline: (+84) 0901235238',
        orderCode: 'Your order number is: {{code}}',
        thanks: 'Thank you for shopping with Billion Girl'
    },
    product: {
        productCode: 'Product Code',
        productName: 'Product Name',
        quantity: 'Quantity',
        price: 'Price',
        discount: 'Discount',
        sellPrice: 'Sell Price',
        availableQuantity: 'Available',
        inventory: 'Inventory',
        finalPrice: 'Final Price',
        active: 'In Business',
        deActive: 'Out of stock',
        displayHomepage: 'Display homepage',
        placeHolderSearchProduct: 'Search by name or product code',
        msgSyncSuccess: 'Sync data success',
        msgSyncFailed: 'Sync data failed',
        msgDeleteSuccess: 'Delete data success',
        msgDeleteFailed: 'Delete data failed',
        name: 'Name',
        description: 'Description',
        descriptionEn: 'Description (EN)',
        image: 'Image',
        color: 'Color',
        size: 'Size',
        category: 'Category',
        optionImage: 'Option Image',
        msgName: 'Name is required!',
        msgPrice: 'Price is required!',
        msgQuantity: 'Quantity is required!',
        msgDescription: 'Description is required!',
        msgImage: 'Image is required!',
        msgColor: 'Color is required!',
        msgSize: 'Size is required!',
        msgCategory: 'Category is required!',
        msgOptionImage: 'Option Image is required!',
        holderColor: 'Select a color',
        holderSize: 'Select a size',
        holderCategory: 'Select a category',
        holderSizeGuide: 'Select a size guide',
        holderDiscount: 'Select a discount',
        imageChange: 'Change Image',
        btnNew: 'New',
        btnAction: 'Action',
        msgDelete: 'Are you sure you want to delete this record?',
        sizeGuide: 'Size Guide',
        relativeProducts: 'Relative products',
        linkProducts: 'Linked products',
        holderRelativeProducts: 'Please select relative product with vary size',
        holderLinkedProducts: 'Please select relative product with vary color',
        msgDisplayProduct: 'Do you want to display the product on the sales page?',
        display: 'Display',
        discountByNumber: 'Discount by products',
        discountNumber: 'Discount number',
        productId: 'ID',
        customColumnDisplay: 'Select display columns',
        status: 'Status',
        onHand: 'On Hand',
        reserved: 'Reserved',
        remainCanBuy: '* Available: {{quantity}}',
        purchaseStatus: 'Purchase status',
        noProductFound: 'No matching products found'
    },
    customer: {
        memberShip: 'Membership',
        totalRevenue: 'Total Revenue',
        totalInvoice: 'Total Invoice',
        dept: 'Dept',
        phone: 'Contact Number',
        email: 'Email',
        customerName: 'Customer Name',
        customerCode: 'Customer Code',
        customerID: 'Customer ID',
        rewardPoint: 'Reward Point',
        role: 'Role',
        province: 'Province',
        district: 'District',
        ward: 'Ward',
        name: 'Name',
        birthday: 'Birthday',
        address: 'Address detail',
        holderSearchUser: 'Search by name, email, customer code or phone number',
        msgUserDoesNotExist: 'User does not exist on KiotViet system'
    },
    promotion: {
        subject: 'Subject',
        content: 'Body',
        author: 'Author',
        sendDate: 'Send date',
        msgSendConfirm: 'Are you sure you want to send this email',
        msgDeleteEmail: 'Delete email success',
        msgSendSuccess: 'Send email success',
        msgSendFailed: 'Send email failed',
        holderSearch: 'Search email template by email subject',
        msgSubjectRequired: 'Subject is required',
        msgContentRequired: 'Content is required'
    },
    paymentMethod: {
        bankName: 'Account Name: {{value}}',
        bankNumber: 'Account number: {{value}}',
        bankInfo: 'Account info: {{value}}',
        selectBank: 'Select account number: ',
        transferContent: 'Transfer Content: ',
        cashContent: 'Direct payment to the delivery man',
        cash: 'Pay on delivery',
        transfer: 'Bank transfer',
        deliveryMethod: 'Shipping method:',
        otherPolicy: 'Policy for provincial customers',
        receiveTime: 'Delivery/Receiving Time'
    },
    policy: {
        txtStore: 'BILLION GIRL',
        txtStoreContact: 'Contact: (+84) 0901235238',
        txtStoreAddress:
            'HCM: 780/10 Su Van Hanh, Ward 12, District 10 | Hanoi: 3rd Floor, 82 Nguyen Luong Bang, Dong Da, Hanoi',
        txtPayment7: 'Transfer content:',
        txtPayment8: '1 - Name',
        txtPayment9: '2 - Phone number',
        txtReadMore: 'Read more: ',
        shoppingGuideContent:
            '<p><strong>Shopping at BILLIONGIRL is easy. You just need to follow these steps:</strong></p><ol><li>Select the product type (dress, skirt, blazer, jean, etc.).</li><li>Chose the product you are interested in and then click on the photo to enlarge and see all details, available sizes, colors and prices.</li><li>Select the item of clothing and add the item to the cart. You can then choose to continue shopping or process your order.</li><li>If you want to process your order, you can do so by registering or paying as a guest.</li><li>Choose a delivery method.</li><li>Select a payment method.</li><li>Order confirmation.</li><li>You will receive an order confirmation email and call.</li></ol>',
        paymentGuideContent1:
            '<p><strong>What payment methods can I use to make purchases?</strong></p><ul><li>When shopping at www.billiongirl.vn, you can choose one of the following payment methods for the most convenient and fastest way:</li><li>Customers buy and pay directly at the store of www.billiongirl.vn</li><li>Payment by bank transfer: you can transfer to us according to the following account information:</li></ul>',
        paymentGuideContent2:
            '<p>** CUSTOMERS PLEASE TRANSFER IN 24 HOURS AFTER ORDER TO GET CONFIRMATION, AFTER 48 HOURS NOT RECEIVING THE PAYMENT, BILLIONGIRL WILL GIVE THE CANCELLATION OF THE ORDER**</p><p>Immediately after receiving the payment from the customer via wire transfer, we will confirm the order information for you and assist in the delivery of goods according to the contractual agreement or directly with the customer.</p><p>Pay on Delivery (COD).</p>',
        deliveryGuideContent:
            '<p><strong>Where can I get my order?</strong></p><p>Orders can be sent to an address chosen by you (home, work, etc. - not a PO Box).</p><p><strong>How long will it take for my order to arrive?</strong></p><p>Normally, www.billiongirl.vn will confirm the order within 24 working hours and deliver the goods to the customer within about 03 working days for inner city customers and 07 days for customers in other provinces from the date of confirmation take orders with customers. However, there are also cases where the delivery takes longer than a few business days, but only in the following force majeure situations:</p><ul><li>The staff of www.billiongirl.vn could not contact customers by phone, so they could not deliver the goods.</li><li>The shipping address you provided is incorrect or difficult to find.</li><li>The number of orders of www.billiongirl.vn suddenly increased, causing the processing of orders to be slow.</li><li>The partner delivers goods to www.billiongirl.vn later than expected, causing the delivery to be delayed or the shipping partner to deliver the goods.</li></ul><p><strong>How much do I have to pay for the delivery service?</strong></p><p>The delivery fee is 30,000 VND for all areas (Diamond customers are exempt from this fee).</p><p>FREE shipping cost for orders made by DIAMOND customer account.</p><p><strong>Can I track my order?</strong></p><p>Yes. You can view the updated status of your order at any time. To do this, go to the "Purchase History" section of your account.</p><p><strong>What is the home delivery process?</strong></p><p>If you choose home delivery, we will send you an email confirming that the item has been confirmed, after which the courier will notify you of the delivery.</p>',
        commonQuestion:
            '<p><strong>Where do we sell online?</strong></p><p>You can now shop online all over Vietnam.</p><p><strong>In how many languages ​​can the website be viewed?</strong></p><p>There are 2 language options to view the BILLIONGIRL page: Vietnamese and English</p><p><strong>Are the prices on the online store the same as those in the regular BILLIONGIRL store?</strong></p><p>Yes. However, if there is a difference between the price displayed on the website and the price on the product label, the correct price will be the price shown on the purchase invoice.</p><p><strong>Will I receive the same product as in the picture?</strong></p><p>Yes. The photos on the BILLIONGIRL site are taken by myself, so the product you receive will be exactly the same as in the pictures.</p><p><strong>Is it possible to periodically receive information via email about the latest BILLIONGIRL products and offers?</strong></p><p>Yes. Just provide your email in the newsletter subscription, you will receive information about BILLIONGIRL latest products, collections and events via email.</p><p><strong>How do I recover a password I forgot?</strong></p><p>If you forget your password, you can recover it in the Login section. Enter your email address and we will send you an email telling you what you need to do.</p><p><strong>How can I make sure I have made the right purchase?</strong></p><p>After placing your order, you will receive a confirmation email and call. If you do not receive emails and calls, contact our customer service.</p><p><strong>Can I track my order?</strong></p><p>Yes. You can view the updated status of your order at any time. To do this, go to the "Order history" section of your account.</p><p>If you are not registered, please click on the "Order information" link in the confirmation email sent to you.</p><p><strong>Can I remove an item from my order?</strong></p><p>Yes. You can remove any unwanted items from your shopping cart, as long as the order has not been processed.</p><p><strong>Can I cancel my order?</strong></p><p>Yes. You can cancel your order, as long as the status of the order is still pending. To do this, contact the customer support hotline at (+84) 0901235238.</p><p><strong>What should I do if I receive a defective item or receive an item that is not what I ordered?</strong></p><p>BILLIONGIRL only sells items in perfect condition and will thoroughly inspect your order before sending it out for shipping, so in the rare event of receiving a defective or wrong item, please contact us. with our customer service.</p>',
        returnPolicyContent:
            '<p>Purchase receipt or credit card receipt must be provided upon exchange.</p><p>The product has its tags intact and has not been used.</p><p>Returns must be made within 7 days from the date of receipt.</p><p>You can only exchange 1 time for 1 purchase invoice.</p><p>1. Applicable cases:</p><ul><li>You can change the size on the same product and 1 color. If the product is out of size, you can exchange it for another product.</li><li>You can exchange products when defective due to shipping, defective due to manufacturing, defective due to technical.</li></ul><p>2. Cases not applicable:</p><ul><li>The products are contaminated with strange odors such as perfume, fabric softener, laundry detergent, etc., when used.</li><li>Products that lose form on wear as specified by BillionGirl, accessories and underwear.</li><li>Products from the sale or from the Outlet store.</li><li>Products that are not eligible for exchange.</li></ul>',
        returnGuideContent:
            '<p><strong>Step 1: Confirm the status of the exchange</strong></p><ul><li>If the product is in defective cases, the customer will take pictures of the current status of the product. Then contact our Customer Care department directly at (+84) 0901235238 or send pictures and feedback to email address cskh.billiongirl.vn@gmail.com to notify information and send pictures to us to confirm.</li></ul><p><strong>Step 2: We confirm</strong></p><ul><li>After receiving the information, we will confirm the status of the goods and confirm for the customer whether to exchange or not.</li><li>After confirming that the goods are accepted for exchange, please keep the goods in their original condition with our product labels, along with the Payment Invoice, Receipt Invoice.</li></ul><p><strong>Step 3: Customers send goods</strong></p><ul><li>Please return the product with the documents mentioned in Step 2 to us at the address: BILLIONGIRL ONLINE STORE | HCM: 780/10 Su Van Hanh, Ward 12, District 10 | Hanoi: 3rd Floor, 82 Nguyen Luong Bang, Dong Da, Hanoi - Phone: (+84) 0901235238</li><li>Customers in Ho Chi Minh City can also come and exchange goods directly at all stores of the BILLIONGIRL system.</li></ul><p><strong>Step 4: We confirm and send the goods to the customer</strong></p><ul><li>After receiving, checking and accepting the product you want to exchange, customer service will contact you to exchange and send the goods back to you.</li></ul><p><strong>Note: Buyer will bear the costs incurred for the exchange.</strong></p>',
        securityContent: `<p><strong>
        Purpose and scope of collection</strong></p><ul><li>The main data collection on website www.billiongirl.vn includes: name, email, phone, customer address,.... This is the information that www.billiongirl.vn needs customers to provide mandatory when registering to use the service and for www.billiongirl.vn to contact to confirm when customers need support and advice. on the website to ensure the interests of consumers.</li><li>Customers will be solely responsible for the security and storage of all service use activities at their email boxes. In addition, customers are responsible for promptly informing website www.billiongirl.vn about unauthorized use, abuse, breach of security, keeping contact information for third parties for measures. suitable solution.</li></ul><p><strong>Scope of information use</strong></p><p>The Company uses user-provided information to:</p><ul><li>Provide services to buyers;</li><li>Delivery to the address provided by the buyer;</li><li>Send marketing and promotional emails about the goods we sell;</li><li>Sending new notices about new product designs as well as new activities to customers of website www.billiongirl.vn;</li><li>Contact and deal with customers in special cases;</li><li>Do not use personal information of customers other than for confirmation and contact purposes related to transactions at www.billiongirl.vn;</li></ul><p><strong>Information storage time</strong></p><ul><li>Personal data of users will be stored during the cooperation between www.billiongirl.vn and customers. The data is only destroyed when the customer completely terminates the transaction activities with www.billiongirl.vn and there is a request to cancel the saving of contact information from the customer.</li><li>In case the user wants to delete all information about the account, please contact us at the address in the contact section.</li></ul><p><strong>Address of the unit that collects and manages personal information</strong></p><ul><li>BILLIONGIRL</li><li>Address: 115 Street No. 1, Ward 4, District 3, Ho Chi Minh City</li><li>Phone: 0986948883</li><li>Email: billiongirl.vn@gmail.com</li><li>If you believe that we have provided your information to a third party without your consent, you have the right to complain to us at the address above. Our company is obliged to resolve issues related to the security of customer information when considering the evidence provided by the user is well-founded.</li></ul><p><strong>Means and tools for users to access and correct their personal data.</strong></p><ul><li>Customers have the right to self-check, update, adjust or cancel their personal information by sending information to be corrected to email: billiongirl.vn@gmail.com</li><li>We will provide technical support to users to correct information if we receive a request from the user.</li></ul><p><strong>Committed to protecting customer's personal information</strong></p><ul><li>Personal information of customers on www.billiongirl.vn is absolutely guaranteed by www.billiongirl.vn in accordance with www.billiongirl.vn personal information protection policy. The collection and use of information of each customer is done only with the consent of that customer, unless otherwise provided for by law.</li><li>Do not use, do not transfer, provide or disclose to any third party about the customer's personal information without the consent of the customer.</li><li>We will provide some information such as: name, address, phone number to the shipping service when using the freight forwarding service.</li><li>In the event that the information server is hacked by a hacker leading to the loss of customer personal data, www.billiongirl.vn will be responsible for notifying the incident to the investigating authorities for timely handling and concurrently. We will also notify customers.</li><li>The management of www.billiongirl.vn requires customers when making a purchase to provide all relevant personal information such as: Full name, contact address, email, identity card number, phone, …, and is responsible for the legality of the above information. The management of www.billiongirl.vn is not responsible for and will not settle all complaints related to the interests of that customer if it considers all the personal information of that customer provided during the initial registration. is incorrect.</li></ul>`,
        deliveryPolicyContent:
            '<p><strong>Shipping method delivery:</strong></p><ul><li>For Customers in Ho Chi Minh City: We will deliver the goods/products to you via the Shipper or through the Courier Company depending on the agreement according to the CONFERENCE INFORMATION that you have provided. provided when ordering.</li><li>For Customers in Other Provinces: We will deliver the goods/products to you via the Courier Company according to the CONFERENCE INFORMATION that you have provided when placing your order.</li></ul><p><strong>Delivery/receipt time:</strong></p><ul><li>For Customers in Ho Chi Minh City: From 2 to 3 days after the order is confirmed (excluding Saturday and Sunday).</li><li>For Customers in Other provinces: From 3 to 7 days after the order is confirmed (excluding Saturday and Sunday).</li><li>In case of overdue delivery/receipt of goods: Please notify our Customer Care Department at phone number (+84) 0901235238 or email address: cskh.billiongirl.vn@gmail.com for support.</li></ul><p><strong>Delivery fee:</strong></p><ul><li>For Customers in Ho Chi Minh City: 30,000 VND/ 1 time fast delivery</li><li>For Customers in Other provinces: 30,000 VND/ 1 standard delivery. 45,000 VND/ 1 time fast delivery</li><li>For orders made by DIAMOND customers: Free Shipping</li></ul>',
        rewardPolicyContent:
            '<p>Billion Girl would like to send to all the ladies - dear customers Announcement about "From 01.09.2022 Billion Girl officially CHANGES &amp; APPLY NEW SHOPPING POINT ACCURACY PROGRAM AT BILLION GIRL"</p><p><strong>A. From September 1, 2022, our service system applies the accumulation program under 3 customer categories:</strong></p><p>1. Standard guest - Standard:</p><ul><li>Conditions of participation: Customers who spend from 1 VND to 9,999,999 VND (except exchange) at Billion Girl system.</li><li>Benefits: can use the purchase - exchange services as prescribed, receive incentives in the birthday month, receive incentives directly from the brand.</li></ul><p>2. Gold - Gold guests:</p><ul><li>Conditions of participation: Customers with spending from 10,000,000 VND to 24,999,999 VND (except exchange) at Billion Girl system.</li><li>Benefits: Customers can apply a fixed discount of 10% and maintain the offer forever, without limitation, without expiration, without requiring to maintain spending times/periods. Customers are allowed to use the purchase - exchange services as prescribed, receive incentives in the birthday month, receive incentives directly from the brand.</li></ul><p>3. Diamond guest class:</p><ul><li>Conditions of participation: Customers with spending from 25,000,000 VND (except exchange) at Billion Girl system.</li><li>Benefits: Customers are entitled to a fixed 15% discount, free 1-way shipping on new orders and maintain the offer forever, unlimited, no expiration, no maintenance required. number of times/interval. Customers are allowed to use the purchase - exchange services as prescribed, receive incentives in the birthday month, receive incentives directly from the brand.</li></ul><p><strong>B. For VIP customers under the Accumulation Program before September 1, 2022</strong></p><ul><li>VIP customers under the old program will be directly upgraded to DIAMOND class under the new program (Note: old VIPs with spending over 10,000,000 VND minus exchange)</li><li>Customers who spend close to the VIP level will receive notifications and support from the Customer Care team to ensure their benefits in the best way.</li></ul><p><br></p><p>BILLION GIRL THANK YOU!</p>'
    },
    agree: 'I agree with policy of Billion Girl',
    btnFinish: 'Finish',
    btnNex: 'Next',
    btnSyncProduct: 'Sync Data',
    btnSyncLoyalty: 'Sync Loyalty',
    btnPrevious: 'Previous',
    stepShipping: 'Shipping',
    stepPayment: 'Payment',
    stepFinish: 'Finish',
    btnBackToShop: 'Home page',
    btnContinues: 'Continues',
    btnFilter: 'Filter',
    btnExplore: 'Explore Now',
    btnShopNow: 'Shop Now',
    btnCheckOut: 'Checkout',
    btnQuickBuy: 'Quick Buy',
    btnAddToCart: 'Add to Cart',
    btnOutOfStock: 'Out of Stock',
    msgSelectSize: 'Please select a size',
    msgOutOfQuantity: 'The product you just purchased is out of stock',
    msgOutOfQuantityOnCart:
        'The product you just purchased already exists in the shopping cart and is out of stock',
    msgNotFound: 'No data found',
    btnLoadMore: 'Load More',
    btnChangeImage: 'Change Image',
    btnAction: 'Action',
    btnNew: 'New',
    btnDelete: 'Delete',
    btnEdit: 'Edit',
    btnClone: 'Clone',
    btnCreate: 'Create',
    btnUpdate: 'Update',
    btnSendEmail: 'Send email',
    msgDelete: 'Are you sure you want to delete this record?',
    titleProductManagement: 'Product',
    titleSystemManagement: 'System',
    titleColorManagement: 'Color',
    titleSizeManagement: 'Size',
    titleSizeGuideManagement: 'Size Guide',
    titleCategoryManagement: 'Category',
    titleImageManagement: 'Image',
    titleDiscountManagement: 'Discount',
    titleUserManagement: 'User',
    titleOrderManagement: 'Orders',
    titleHistoryManagement: 'History',
    titleLayoutManagement: 'Layout',
    titleFollowerManagement: 'Follower',
    titleLogout: 'Log out',
    titleChangePassword: 'Change Password',
    titleProduct: 'Products',
    titleCustomerManagement: 'Customers',
    titleInvoiceManagement: 'Invoices',
    titlePromotionManagement: 'Promotion',
    titleReturnManagement: 'Return',
    titleHomepageSettingManagement: 'Homepage setting',
    titleBankManagement: 'Bank Account',
    txtPassword: 'Password',
    txtEmail: 'Email',
    txtGoToLogin: 'Go to Login',
    txtGoToHome: 'Go to Home',
    txtFailed: 'Failed',
    txtChangePassword: 'Change Password',
    txtSentMailInfo: 'An email has just been sent to {{email}}',
    txtCheckGuide: 'Please check your mailbox and follow the instructions.',
    txtForgotPass: 'Forgot password',
    txtConfirmResetEmail: 'Confirm your email to reset your password',
    txtConfirmResetPhone: 'Confirm your phone to reset your password',
    textInputNameRequired: 'Please enter your name',
    textInputPhoneRequired: 'Please enter your contact number',
    txtInputEmailRequired: 'Please enter email',
    txtInputCurrentPassword: 'Please enter current password',
    txtInputNewPasswordRequired: 'Please enter a new password',
    txtInputConfirmPasswordRequired: 'Please re-enter your password',
    txtFromDate: 'From date',
    txtToDate: 'To date',
    txtStatus: 'Status',
    txtUpdateDate: 'Updated Date',
    placeRequirePassword: 'Please enter a password',
    btnForgotPassword: 'Forgot password?',
    btnLogin: 'Log in',
    btnRegister: 'Register',
    btnConfirm: 'Confirm',
    btnSendRequest: 'Send request',
    btnSave: 'Save',
    btnSync: 'Sync',
    btnSaveAndSend: 'Save & Send',
    btnCancel: 'Cancel',
    btnClose: 'Close',
    btnOK: 'OK',
    btnPay: 'Check out',
    btnShopping: 'Shopping',
    btnBack: 'Back',
    msgSystemError: 'System Error',
    msgTokenNotExist: 'Token does not exist, please try again!',
    msgTokenWrongFormat: 'Invalid token, please try again!',
    msgTokenExpire: 'Token has expired, please try again!',
    msgSamePassword: 'The password is the same as the old password!',
    msgChangePasswordSuccess: 'Change password successfully',
    msgPasswordRequired: 'You need to create a new password before using',
    msgSendEmailFailed: 'Email sending failed!',
    msgEmailNotExist: 'Email does not existed!',
    msgPhoneNotExist: 'Contact number does not existed!',
    msgUserNotExist: 'Customer does not exist in the system',
    msgEmailExisted: 'Email is existed',
    msgPhoneExisted: 'Phone number is existed',
    msgWrongPassWord: 'Wrong password',
    msgSentRequestSuccess: 'Sent request',
    msgSentRequestFailed: 'Submit request failed',
    msgUpdatePasswordSuccess: 'Password has been updated successfully',
    msgWrongLoginPassword: 'The current password is incorrect!',
    msgLogoutConfirm: 'Do you really want to sign out?',
    msgValidateName: 'Minimum {{min}} characters and maximum {{max}} characters',
    msgWarningSyncBackground: 'Your data is being synced background!',
    txtPaginationContent: 'Display {{startRange}} - {{endRange}}/{{total}}',
    titleSuggestion: 'Suggestion',
    sync100: 'Sync 100 newest records',
    sync200: 'Sync 200 newest records',
    sync500: 'Sync 500 newest records',
    sync1000: 'Sync 1000 newest records',
    syncAll: 'Sync all record',
    btnReload: 'Reload',
    btnSubmit: 'Submit',
    btnBackToHome: 'Back to home',
    btnReset: 'Reset',
    systemContactNumber: '(+84) 0901235238'
};

export default en;
